import axios from "axios";

const URL = 'https://isolution.dev.br:8083/adm';
//const URL = 'http://localhost:8083/adm';

const api = axios.create({
    baseURL: URL
});

export default api;